<div
    class="btn-group p-2 p-lg-0"
    dropdown
    #dropdown="bs-dropdown"
    [dropup]="stepButton().isDropup"
    [isDisabled]="stepButton().entries.length === 0"
>
    @if (stepButton().primary; as primary) {
        @if (stepButton().primaryOpensDropdown) {
            <!-- A remote status has to be picked explicitly, so the main half only opens the menu. -->
            <button
                class="btn btn-primary btn-lg split-button px-0 me-auto d-lg-none d-block"
                type="button"
                [disabled]="stepButton().isBusy"
                (click)="dropdown.toggle(true)"
            >
                {{ primary.label }}
            </button>
        } @else {
            <button
                type="button"
                class="btn btn-primary btn-lg split-button px-0 me-auto"
                [disabled]="stepButton().isBusy"
                (click)="actionSelect.emit(primary)"
            >
                @if (stepButton().isBusy) {
                    <fa-icon [icon]="faLoading" animation="spin"></fa-icon>
                } @else {
                    {{ primary.label }}
                }
            </button>
        }
    }

    @if (stepButton().entries.length > 0) {
        @if (stepButton().isDropup) {
            <button
                class="more-toggler d-lg-none btn btn-secondary btn-lg ms-2"
                type="button"
                (click)="dropdown.toggle(true)"
                [attr.aria-label]="stepButton().menuAriaLabel"
                [disabled]="stepButton().isBusy"
            >
                <fa-icon [icon]="faEllipsisV"></fa-icon>
            </button>
        } @else {
            <button
                type="button"
                id="button-split"
                class="btn btn-primary btn-lg dropdown-toggle dropdown-toggle-split d-lg-block d-none"
                (click)="dropdown.toggle(true)"
                [attr.aria-label]="stepButton().menuAriaLabel"
                [disabled]="stepButton().isBusy"
            >
                @if (stepButton().primaryOpensDropdown && stepButton().primary; as primary) {
                    <span class="pe-3">{{ primary.label }}</span>
                    <span class="caret"></span>
                    <span class="visually-hidden">Toggle Dropdown</span>
                }
            </button>
        }
    }

    <ul
        class="dropdown-menu dropdown-menu-right"
        *dropdownMenu
        id="dropdown-split"
        role="menu"
        aria-labelledby="button-split"
    >
        @for (entry of stepButton().entries; track entry.id) {
            <li [class]="stepButton().dimClass" role="menuitem">
                <button
                    class="btn btn-secondary btn-lg"
                    type="button"
                    [disabled]="entry.isDisabled"
                    (click)="actionSelect.emit(entry)"
                >
                    @if (entry.showRemoteIcon) {
                        <fa-icon class="float-start" [icon]="faPhone" size="sm"></fa-icon>
                    }
                    {{ entry.label }}
                </button>
            </li>
        }
    </ul>
</div>
